import { motion } from "framer-motion";


function Layout({children}){
    return(
        <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
        >
            {children}
        </motion.div>
    )

}
// const mapStateToProp = state => ({

// })
// export default connect(mapStateToProp,{

// }) (Layout);

export default Layout;
